// #region Imports
import React, { useState } from 'react';
import useConfiguracoes from '../../hooks/useConfiguracoes';
import './Configuracoes-Page.scss';
// #endregion

// #region Componentes auxiliares
function Toggle({ label, value, onChange, ariaLabel }) {
  return (
    <div className="toggle-row">
      <span>{label}</span>
      <label className="switch">
        <input
          type="checkbox"
          checked={!!value}
          onChange={e => onChange(e.target.checked)}
          aria-label={ariaLabel || label}
        />
        <span className="slider" />
      </label>
    </div>
  );
}
// #endregion

// #region Util UI
const TABS = ['salao', 'vendas', 'sistema', 'notificacoes', 'backup'];
function labelTab(t) {
  switch (t) {
    case 'salao': return 'Salão';
    case 'vendas': return 'Vendas';
    case 'sistema': return 'Sistema';
    case 'notificacoes': return 'Notificações';
    default: return 'Backup';
  }
}
// #endregion

// #region Página principal
export default function ConfiguracoesPage() {
  // #region Hook domínio
  const {
    config,
    patchConfig,
    save,
    reset,
    limparDados,
    loading,
    saving,
    dirty,
  } = useConfiguracoes();
  // #endregion

  // #region Estado UI
  const [tab, setTab] = useState('salao');
  // #endregion

  // #region Handlers
  async function handleSave() { await save(); }
  // #endregion

  // #region Render helpers (por aba)
  function renderSalao() {
    return (
      <div className="config-grid">
        <div className="config-card">
          <h3>📋 Informações do Salão</h3>
          <p className="desc">Dados básicos do seu estabelecimento</p>
          <div className="fields">
            <div>
              <label htmlFor="f-nome-salao">Nome do Salão</label>
              <input
                id="f-nome-salao"
                value={config.nome_salao}
                onChange={e => patchConfig({ nome_salao: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="f-cnpj">CNPJ</label>
              <input
                id="f-cnpj"
                value={config.cnpj}
                onChange={e => patchConfig({ cnpj: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="f-telefone">Telefone</label>
              <input
                id="f-telefone"
                value={config.telefone}
                onChange={e => patchConfig({ telefone: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="f-endereco">Endereço</label>
              <textarea
                id="f-endereco"
                value={config.endereco}
                onChange={e => patchConfig({ endereco: e.target.value })}
              />
            </div>
          </div>
        </div>
        <div className="config-card">
          <h3>⏱ Horário de Funcionamento</h3>
          <p className="desc">Configure os horários de abertura e fechamento</p>
          <div className="fields two">
            <div>
              <label>Segunda a Sexta (Início)</label>
              <input
                value={config.seg_sex_inicio}
                onChange={e => patchConfig({ seg_sex_inicio: e.target.value })}
              />
            </div>
            <div>
              <label>Segunda a Sexta (Fim)</label>
              <input
                value={config.seg_sex_fim}
                onChange={e => patchConfig({ seg_sex_fim: e.target.value })}
              />
            </div>
            <div>
              <label>Sábado (Início)</label>
              <input
                value={config.sabado_inicio}
                onChange={e => patchConfig({ sabado_inicio: e.target.value })}
              />
            </div>
            <div>
              <label>Sábado (Fim)</label>
              <input
                value={config.sabado_fim}
                onChange={e => patchConfig({ sabado_fim: e.target.value })}
              />
            </div>
          </div>
          <Toggle
            label="Funciona aos domingos"
            value={config.funciona_domingo}
            onChange={v => patchConfig({ funciona_domingo: v })}
          />
          <div className="fields two">
            <div>
              <label>Intervalo Almoço (Início)</label>
              <input
                value={config.almoco_inicio}
                onChange={e => patchConfig({ almoco_inicio: e.target.value })}
              />
            </div>
            <div>
              <label>Intervalo Almoço (Fim)</label>
              <input
                value={config.almoco_fim}
                onChange={e => patchConfig({ almoco_fim: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderVendas() {
    return (
      <div className="config-grid">
        <div className="config-card">
          <h3>💲 Métodos de Pagamento</h3>
          <p className="desc">Configure os métodos aceitos</p>
          <div className="toggle-stack">
            <Toggle label="Dinheiro" value={config.mp_dinheiro} onChange={v => patchConfig({ mp_dinheiro: v })} />
            <Toggle label="Cartão de Débito" value={config.mp_cartao_debito} onChange={v => patchConfig({ mp_cartao_debito: v })} />
            <Toggle label="Cartão de Crédito" value={config.mp_cartao_credito} onChange={v => patchConfig({ mp_cartao_credito: v })} />
            <Toggle label="PIX" value={config.mp_pix} onChange={v => patchConfig({ mp_pix: v })} />
            <Toggle label="Fiado" value={config.mp_fiado} onChange={v => patchConfig({ mp_fiado: v })} />
          </div>
        </div>
        <div className="config-card">
          <h3>💵 Configurações de Caixa</h3>
          <p className="desc">Gerencie o caixa diário</p>
          <div className="fields">
            <div>
              <label>Valor Inicial Padrão (R$)</label>
              <input
                value={config.caixa_valor_inicial_padrao}
                onChange={e => patchConfig({ caixa_valor_inicial_padrao: e.target.value })}
              />
            </div>
            <Toggle
              label="Fechamento automático às 23:59"
              value={config.caixa_fechamento_automatico}
              onChange={v => patchConfig({ caixa_fechamento_automatico: v })}
            />
            <div>
              <label>Limite para Sangria (R$)</label>
              <input
                value={config.caixa_limite_sangria}
                onChange={e => patchConfig({ caixa_limite_sangria: e.target.value })}
              />
            </div>
          </div>
        </div>
        <div className="config-card" style={{ gridColumn: '1 / -1' }}>
          <h3>📌 Configurações de Fiado</h3>
          <p className="desc">Defina regras para vendas fiadas</p>
          <div className="fields three">
            <div>
              <label>Limite Máximo (R$)</label>
              <input
                value={config.fiado_limite_maximo}
                onChange={e => patchConfig({ fiado_limite_maximo: e.target.value })}
              />
            </div>
            <div>
              <label>Prazo Padrão (dias)</label>
              <input
                value={config.fiado_prazo_padrao_dias}
                onChange={e => patchConfig({ fiado_prazo_padrao_dias: e.target.value })}
              />
            </div>
            <div>
              <label>Desconto Máximo (%)</label>
              <input
                value={config.fiado_desconto_maximo}
                onChange={e => patchConfig({ fiado_desconto_maximo: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderSistema() {
    return (
      <div className="config-grid">
        <div className="config-card">
          <h3>📦 Estoque</h3>
          <p className="desc">Configurações gerais de estoque</p>
          <div className="fields">
            <div>
              <label>Estoque Mínimo Global</label>
              <input
                value={config.estoque_minimo_global}
                onChange={e => patchConfig({ estoque_minimo_global: e.target.value })}
              />
            </div>
            <div>
              <label>Alerta de Vencimento (dias)</label>
              <input
                value={config.alerta_vencimento_dias}
                onChange={e => patchConfig({ alerta_vencimento_dias: e.target.value })}
              />
            </div>
            <Toggle
              label="Controle de lotes"
              value={config.controle_lotes}
              onChange={v => patchConfig({ controle_lotes: v })}
            />
          </div>
        </div>
        <div className="config-card">
          <h3>🎨 Aparência</h3>
          <p className="desc">Personalize a interface</p>
          <div className="fields">
            <div>
              <label>Tema</label>
              <select
                value={config.tema}
                onChange={e => patchConfig({ tema: e.target.value })}
              >
                <option value="SISTEMA">Sistema</option>
                <option value="CLARO">Claro</option>
                <option value="ESCURO">Escuro</option>
              </select>
            </div>
            <div>
              <label>Cor Principal</label>
              <div className="color-palette">
                {['PINK', 'LIGHT', 'YELLOW'].map(c => (
                  <div
                    key={c}
                    role="button"
                    tabIndex={0}
                    className={`color-swatch ${config.cor_principal === c ? 'active' : ''}`}
                    data-color={c}
                    onClick={() => patchConfig({ cor_principal: c })}
                    onKeyDown={e => { if (e.key === 'Enter') patchConfig({ cor_principal: c }); }}
                    aria-label={`Selecionar cor ${c}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="config-card" style={{ gridColumn: '1 / -1' }}>
          <h3>🛡 Segurança</h3>
          <p className="desc">Configurações de segurança e acesso</p>
          <div className="fields">
            <Toggle
              label="Bloquear após inatividade"
              value={config.bloquear_inatividade}
              onChange={v => patchConfig({ bloquear_inatividade: v })}
            />
            <div>
              <label>Tempo para bloqueio (minutos)</label>
              <input
                value={config.tempo_bloqueio_min}
                onChange={e => patchConfig({ tempo_bloqueio_min: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderNotificacoes() {
    return (
      <div className="config-card">
        <h3>🔔 Notificações</h3>
        <p className="desc">Configure alertas e lembretes importantes</p>
        <div className="toggle-stack">
          <Toggle label="Estoque Baixo" value={config.notif_estoque_baixo} onChange={v => patchConfig({ notif_estoque_baixo: v })} />
          <Toggle label="Produtos Vencendo" value={config.notif_produtos_vencendo} onChange={v => patchConfig({ notif_produtos_vencendo: v })} />
          <Toggle label="Comissões Pendentes" value={config.notif_comissoes_pendentes} onChange={v => patchConfig({ notif_comissoes_pendentes: v })} />
          <Toggle label="Fiados Vencidos" value={config.notif_fiados_vencidos} onChange={v => patchConfig({ notif_fiados_vencidos: v })} />
          <Toggle label="Backup Automático" value={config.notif_backup_automatico} onChange={v => patchConfig({ notif_backup_automatico: v })} />
        </div>
      </div>
    );
  }

  function renderBackup() {
    return (
      <div className="config-grid">
        <div className="config-card">
          <h3>💽 Backup dos Dados</h3>
          <p className="desc">Proteja seus dados com backups regulares</p>
          <Toggle
            label="Backup automático diário"
            value={config.backup_automatico_diario}
            onChange={v => patchConfig({ backup_automatico_diario: v })}
          />
          <div className="backup-actions">
            <div style={{ fontSize: '.85rem', color: 'var(--text-light, #697580)' }}>
              Último backup: {config.ultimo_backup_info}
            </div>
            <button type="button" onClick={() => window.alert('Backup simulado.')}>Fazer Backup Agora</button>
            <button type="button" onClick={() => window.alert('Restaurar backup simulado.')}>Restaurar Backup</button>
          </div>
        </div>
        <div className="config-card">
          <h3>⚠ Gerenciar Dados</h3>
          <p className="desc">Opções avançadas de dados</p>
          <div className="danger-zone">
            <h4>Zona de Perigo</h4>
            <p style={{ margin: 0, fontSize: '.75rem' }}>Estas ações são irreversíveis. Use com cuidado.</p>
            <button
              type="button"
              className="danger-btn"
              onClick={() => { if (window.confirm('Limpar dados de teste?')) limparDados(); }}
            >
              Limpar Dados de Teste
            </button>
            <button
              type="button"
              className="danger-btn"
              onClick={() => { if (window.confirm('Resetar configurações para padrão?')) reset(); }}
            >
              Resetar Configurações
            </button>
          </div>
        </div>
        <div className="config-card" style={{ gridColumn: '1 / -1' }}>
          <h3>ℹ Informações do Sistema</h3>
          <div className="system-info">
            <div className="info-box">
              <span className="info-label">Versão</span>
              <span className="info-value">{config.versao_sistema}</span>
            </div>
            <div className="info-box">
              <span className="info-label">Banco de Dados</span>
              <span className="info-value">{config.banco_dados}</span>
            </div>
            <div className="info-box">
              <span className="info-label">Última Sincronização</span>
              <span className="info-value">{config.ultima_sincronizacao}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  // #endregion

  // #region Render
  return (
    <div className="config-page">
      <div className="config-header-top">
        <h1>Configurações</h1>
        <p className="subtitle">Gerencie as configurações do seu salão de beleza</p>
      </div>
      <div className="config-header-actions">
        <button
          type="button"
          className="btn-save-config"
          onClick={handleSave}
          disabled={loading || saving || !dirty}
        >
          💾 Salvar Alterações{saving ? '...' : ''}
        </button>
      </div>
      <div className="config-tabs">
        {TABS.map(t => (
          <button
            key={t}
            type="button"
            className={tab === t ? 'active' : ''}
            onClick={() => setTab(t)}
          >
            {labelTab(t)}
          </button>
        ))}
      </div>
      {tab === 'salao' && renderSalao()}
      {tab === 'vendas' && renderVendas()}
      {tab === 'sistema' && renderSistema()}
      {tab === 'notificacoes' && renderNotificacoes()}
      {tab === 'backup' && renderBackup()}
    </div>
  );
  // #endregion
}
